import apiService from '../index';

class FixturesManager {
  constructor() {
    this.apiService = apiService;
  }

  async fetchFixtures(leagueId, season) {
    try {
      console.log(`Fetching fixtures data for league ID ${leagueId}, season ${season} using FixturesManager...`);
      
      // Используем метод get, который уже проверяет кэш и делает запрос к API только если нужно
      const response = await this.apiService.getFixtures(leagueId, season);
      
      if (response.status === 'error') {
        console.error('Error fetching fixtures:', response.message);
        return response;
      }
      
      return {
        status: 'success',
        data: response.data,
        endpoint: 'fixtures',
        params: { leagueId, season },
        fromCache: response.fromCache
      };
    } catch (error) {
      console.error('Error in FixturesManager:', error);
      return {
        status: 'error',
        message: error.message,
        endpoint: 'fixtures'
      };
    }
  }


  async fetchFixturesByDateRange(leagueId, fromDate, toDate, season) {
    try {
      console.log(`Fetching fixtures for league ID ${leagueId}, from ${fromDate.toISOString().split('T')[0]} to ${toDate.toISOString().split('T')[0]}, season ${season} using FixturesManager...`);
      
      const response = await this.apiService.fetchFixtures(leagueId, fromDate, toDate, season);
      
      if (response.status === 'error') {
        console.error('Error fetching fixtures by date range:', response.message);
        return response;
      }
      
      return {
        status: 'success',
        data: response.data,
        endpoint: 'fixtures',
        params: { leagueId, season,fromDate: fromDate.toISOString().split('T')[0], toDate: toDate.toISOString().split('T')[0] },
        fromCache: response.fromCache
      };
    } catch (error) {
      console.error('Error in FixturesManager:', error);
      return {
        status: 'error',
        message: error.message,
        endpoint: 'fixtures'
      };
    }
  }
}

export default new FixturesManager(); 